function isNumber(value){return typeof value === 'number';}
function isDefined(value){return typeof value != 'undefined';}

class D3Format {
	static number(val, nullOption) {
		if(isNumber(val)) {
			return window.d3.format(',')(val);
		}
		else {
			if(val == null) {
				if(isDefined(null)) {
					return nullOption;
				}
				else {
					return null;
				}
			}
			else {
				return val;
			}
		}
	}
}

export default D3Format;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/ui/D3Format.js